var _line, _line2, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTinyGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 322,
    height: 218,
    viewBox: "0 0 322 218",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 33.1021,
    y1: 135.636,
    x2: 180.245,
    y2: 66.0101,
    stroke: "#202531",
    strokeWidth: 8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 182.07,
    y1: 66.87,
    x2: 289.295,
    y2: 179.664,
    stroke: "#202531",
    strokeWidth: 8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 181.956,
    cy: 69.6262,
    r: 69.1262,
    fill: "#E50C33",
    stroke: "#202531"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.8131,
    cy: 139.253,
    r: 34.3131,
    fill: "#FDA800",
    stroke: "#202531"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 286.396,
    cy: 182.421,
    r: 34.3131,
    fill: "#0196BF",
    stroke: "#202531"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTinyGraph);
export default __webpack_public_path__ + "static/media/tinyGraph.d01e734e5afa260edee8d199fda7cb5f.svg";
export { ForwardRef as ReactComponent };